import React from "react";
const HomeSlider = () => {
  return (
    <>
      <div className="slider-sec">
        <div
          id="carouselExampleCaptions"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner">
            {/* <div className="carousel-item active" data-bs-interval="3000">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/sld-6.jpg"
                className="d-block w-100"
                alt="MGM bokaro"
              />{" "}
            </div> */}

            <div className="carousel-item active" data-bs-interval="3000">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/sld-7.jpeg"
                className="d-block w-100"
                alt="MGM bokaro"
              />{" "}
            </div>

            <div className="carousel-item" data-bs-interval="3000">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/sld-5.jpg"
                className="d-block w-100"
                alt="MGM bokaro"
              />{" "}
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/sld-0.JPEG"
                className="d-block w-100"
                alt="MGM bokaro"
              />{" "}
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/sld-1.JPG"
                className="d-block w-100"
                alt="MGM bokaro"
              />{" "}
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/sld-2.jpg"
                className="d-block w-100"
                alt="MGM bokaro"
              />{" "}
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/sld-3.jpg"
                className="d-block w-100"
                alt="MGM bokaro"
              />{" "}
            </div>
            <div className="carousel-item" data-bs-interval="3000">
              {" "}
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MGMB/public/Images/sld-4.jpg"
                className="d-block w-100"
                alt="MGM bokaro"
              />{" "}
            </div>
          </div>{" "}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            {" "}
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>{" "}
            <span className="visually-hidden">Previous</span>{" "}
          </button>{" "}
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            {" "}
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>{" "}
            <span className="visually-hidden">Next</span>{" "}
          </button>
        </div>
      </div>
    </>
  );
};

export default HomeSlider;
